import React from 'react';
export function ContactPage() {
  return <div className="pt-32 pb-20" data-id="element-5933">
      <div className="max-w-3xl mx-auto px-6 text-center mb-16" data-id="element-5934">
        <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-5935">Get in touch</h1>
        <p className="text-lg text-textMuted" data-id="element-5936">
          Have questions about Booker? We're here to help.
        </p>
      </div>

      <div className="max-w-xl mx-auto px-6" data-id="element-5937">
        <div className="bg-surface border border-border rounded-2xl p-8" data-id="element-5938">
          <form className="space-y-4" data-id="element-5939">
            <div data-id="element-5940">
              <label className="block text-sm font-medium mb-2" data-id="element-5941">Name</label>
              <input type="text" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5942" />
            </div>
            <div data-id="element-5943">
              <label className="block text-sm font-medium mb-2" data-id="element-5944">Email</label>
              <input type="email" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5945" />
            </div>
            <div data-id="element-5946">
              <label className="block text-sm font-medium mb-2" data-id="element-5947">Topic</label>
              <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5948">
                <option data-id="element-5949">General Inquiry</option>
                <option data-id="element-5950">Support</option>
                <option data-id="element-5951">Billing</option>
                <option data-id="element-5952">Partnerships</option>
              </select>
            </div>
            <div data-id="element-5953">
              <label className="block text-sm font-medium mb-2" data-id="element-5954">Message</label>
              <textarea rows={5} className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-5955"></textarea>
            </div>
            <button type="button" className="w-full py-3 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors mt-4" data-id="element-5956">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>;
}